import { DoctorSimple } from '@dreryk/egabinet-personnel-frontend-api';
import { PatientGroup } from '@dreryk/egabinet-patient-frontend-api';

import { ActionBar, ButtonVariant, Header, MarginPosition } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';

import { prescriptionVisitsTranslationKeys } from '../translations';
import { AppointmentsFiltersContextProvider } from '../appointment/filters/AppointmentFilter.context';
import { AppointmentsFilterChips } from '../appointment/filters/AppointmentsFilterChips/AppointmentsFilterChips';
import { AppointmentsFilterPanel } from '../appointment/filters/AppointmentsFilterPanel/AppointmentsFilterPanel';

import { AddPrescriptionVisitModalOpener } from './actionBar/AddPrescriptionVisitModal.opener';
import { PrescriptionVisitsTable } from './table/PrescriptionVisitsTable';

type PrescriptionVisitsPanelProps = {
   readonly doctors: DoctorSimple[];
   readonly currentDoctor: DoctorSimple | null;
   readonly patientGroups: PatientGroup[];
   readonly onlinePaymentsIntegrationExists: boolean;
};

export const PrescriptionVisitsPanel = (props: PrescriptionVisitsPanelProps): JSX.Element => {
   const doctorsFilterAvailable = protectFeature('searchingAllPractitioners') && props.doctors.length > 1;

   return (
      <AppointmentsFiltersContextProvider>
         <Header testId={'prescriptionVisits'} margin={MarginPosition.NONE}>
            {prescriptionVisitsTranslationKeys.title}
         </Header>
         <AppointmentsFilterPanel
            currentDoctor={props.currentDoctor}
            doctors={props.doctors}
            patientGroups={props.patientGroups}
            doctorsFilterAvailable={doctorsFilterAvailable}
            extendedFiltersAvailable={false}
         />
         <AppointmentsFilterChips
            doctors={props.doctors}
            patientGroups={props.patientGroups}
            doctorsFilterAvailable={doctorsFilterAvailable}
         />
         <PrescriptionVisitsTable
            currentDoctor={props.currentDoctor}
            doctors={props.doctors}
            onlinePaymentsIntegrationExists={props.onlinePaymentsIntegrationExists}
         />
         <ActionBar id={'prescriptionVisits-action-bar'} testId={'prescriptionVisits'}>
            <AddPrescriptionVisitModalOpener>
               {({ openModal }) => (
                  <ActionBar.PrimaryButton
                     testId={'addPrescriptionVisit'}
                     label={prescriptionVisitsTranslationKeys.addPrescriptionVisit}
                     onClick={openModal}
                     variant={ButtonVariant.PRIMARY}
                  />
               )}
            </AddPrescriptionVisitModalOpener>
         </ActionBar>
      </AppointmentsFiltersContextProvider>
   );
};
